import React, { memo } from 'react'
import type { ClusterMarkerProps } from './types'

const getClusterIconSize = (count: number) => {
  if (count >= 200) {
    return 80
  } else if (count >= 100) {
    return 70
  } else if (count >= 50) {
    return 60
  } else if (count >= 20) {
    return 50
  } else if (count >= 10) {
    return 40
  }
  return 30
}

export const ClusterPinComponent = memo(({ markers }: ClusterMarkerProps) => {
  const mainColor = process.env.NEXT_PUBLIC_MAIN_COLOR
  const subColor = process.env.NEXT_PUBLIC_SUB_COLOR
  return (
    <div className={'pin'}>
      {markers.length}
      <style jsx>{`
      .pin {
        width: ${getClusterIconSize(markers.length)}px;
        height: ${getClusterIconSize(markers.length)}px;

        background: ${mainColor ? mainColor : 'rgba(255, 198, 0)'};
        color: ${subColor ? subColor : 'rgba(0, 0, 0)'};
        opacity: 0.7;
        border-radius: 100%;
        border: 0.125rem solid ${subColor ? subColor : 'rgba(0, 0, 0)'};
        transition: all 0.3s;

        display: flex;
        align-items: center;
        justify-content: center;

        z-index: 1;
        transform-origin: 0 0;
        transform: translate(-50%, -50%);

        font-size: ${markers.length > 100 ? '18px' : '20px'};
      }
    `}</style>
    </div>
  )
})
